<template>
    <div>
        <iframe src="http://zxgk.court.gov.cn/zhzxgk/" width="100%" :height="height"/>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'shixin',
        data() {
            return {
                height: document.documentElement.clientHeight + 10 + 'px'
            }
        },
        components: {},
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>

</style>
